import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* Material */
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';

/* translation */
import { TranslateModule } from '@ngx-translate/core';

/* LiveDOK modules*/
import { SharedModule } from '../shared/shared.module';
import { WebDokuModule } from '../web-doku/web-doku.module';
import { DocumentsModule } from '../documents/documents.module';

/* local components */
import { InfoChangedComponent } from './info-changed/info-changed.component';
import { InfoHistoryComponent } from './info-history/info-history.component';
import { InfoWebdokuComponent } from './info-webdoku/info-webdoku.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [InfoChangedComponent, InfoHistoryComponent, InfoWebdokuComponent],
  exports: [InfoChangedComponent, InfoHistoryComponent, InfoWebdokuComponent],
  imports: [
    CommonModule,
    SharedModule,
    WebDokuModule,
    MatTableModule,
    TranslateModule,
    MatToolbarModule,
    DocumentsModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    RouterModule,
  ],
})
export class InfoModule {}
